var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    document.querySelectorAll(".accordion").forEach(e => {
      if(this != e) {
        e.classList.remove("active");
        const panelId = e.dataset.panel;
        document.querySelector(`#${panelId}`).style.maxHeight = null;
        // e.target.nextElementSibling.style.maxHeight = null;
      }
    })

    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}